// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__kADQ0","content":"GlobalSearch_content__TTA5a"};